// extracted by mini-css-extract-plugin
export default {"layer":"pageRobot_layer__OMu0A","canvas":"pageRobot_canvas__RKa40"};